import { render } from "./comments.html?vue&type=template&id=09f232fc&external"
import script from "./comments.js?vue&type=script&lang=js&external"
export * from "./comments.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__